// Product Page Tab Section 
$(document).ready(function() {
    const $tabLinks = $('.tab-link');
    const $tabContents = $('.tab-content');
    $tabContents.hide().first().show();
    $tabLinks.first().addClass('active');
    $tabLinks.on('click', function(e) {
      e.preventDefault();
      $tabContents.hide();
      $tabLinks.removeClass('active');
      const tabId = $(this).data('tab-id');
      $(`#tab-${tabId}`).show();
      $(this).addClass('active');
    });
});


// Information of photocredit
document.addEventListener("DOMContentLoaded", function () {
  const infoIcons = document.querySelectorAll(".info-icon");
  const photoCredits = document.querySelectorAll(".photo-credit");
  const closeButtons = document.querySelectorAll(".close-btn");

  // Open Photo Credit
  infoIcons.forEach((icon) => {
      icon.addEventListener("click", function (e) {
          // Prevent click from bubbling up to document
          e.stopPropagation();
          // Find the closest parent grid item and its photo credit div
          const gridItem = this.closest('.photo-gallery-grid-item');
          const photoCredit = gridItem.querySelector('.photo-credit');
          
          photoCredit.classList.add("active");
          icon.classList.add("hide");
      });
  });

  // Close Photo Credit
  closeButtons.forEach((button) => {
      button.addEventListener("click", function (e) {
          // Prevent click from bubbling up to document
          e.stopPropagation();
          const gridItem = this.closest('.photo-gallery-grid-item');
          const photoCredit = gridItem.querySelector('.photo-credit');
          const infoIcon = gridItem.querySelector('.info-icon');

          photoCredit.classList.remove("active");
          infoIcon.classList.remove("hide");
      });
  });

  // Close when clicking outside
  document.addEventListener("click", function (event) {
      photoCredits.forEach((photoCredit) => {
          if (!photoCredit.contains(event.target)) {
              const gridItem = photoCredit.closest('.photo-gallery-grid-item');
              const infoIcon = gridItem.querySelector('.info-icon');
              
              photoCredit.classList.remove("active");
              infoIcon?.classList.remove("hide");
          }
      });
  });
});

// Readmore link functionality 
$(document).ready(function () {
    function AddReadMore() {
        var readMoreTxt = " ...read more";
        var readLessTxt = " read less";
        var wordLimit = 66; // Adjust word limit as needed

        $(".add-read-more").each(function () {
            if ($(this).find(".first-section").length) return;

            var allText = $(this).html();
            var words = allText.split(" ");

            if (words.length <= wordLimit) return; // Don't modify if text is already short

            var firstPart = words.slice(0, wordLimit).join(" ");
            var secondPart = words.slice(wordLimit).join(" ");

            var newContent = `${firstPart} <span class="second-section" style="display: none;">${secondPart}</span>
                <span class="read-more">${readMoreTxt}</span>
                <span class="read-less" style="display: none;">${readLessTxt}</span>`;

            $(this).html(newContent);
        });

        $(document).on("click", ".read-more", function () {
            var parent = $(this).closest(".add-read-more");
            var secondSection = parent.find(".second-section");

            secondSection.css({ display: "inline" }).hide().slideDown(300); // Smooth slide inline
            parent.find(".read-more").hide();
            parent.find(".read-less").show();
        });

        $(document).on("click", ".read-less", function () {
            var parent = $(this).closest(".add-read-more");
            var secondSection = parent.find(".second-section");

            secondSection.slideUp(300, function () {
                $(this).css("display", "none");
            }); // Smooth collapse
            parent.find(".read-less").hide();
            parent.find(".read-more").show();
        });
    }

    AddReadMore();
});







